import * as React from "react";
import { Context } from "./_context";
export const CategoryDepartmentStoreIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22 7.5h-4.987L8.312 19.584A1 1 0 0 1 7.5 20H2v-2h2.064l.261-3.907a3.849 3.849 0 0 1 6.937-2.03l4.128-5.732a2 2 0 0 1 1.623-.831H22v2Zm-13.835 5c-.973 0-1.78.755-1.845 1.726L6.07 18h.918l2.964-4.117A1.848 1.848 0 0 0 8.165 12.5ZM8 4a2.75 2.75 0 1 1 0 5.5A2.75 2.75 0 0 1 8 4Zm0 2a.75.75 0 1 0 0 1.5A.75.75 0 0 0 8 6Z", fill: "currentColor" }));
  return iconset[size];
};
CategoryDepartmentStoreIcon.iconId = "BiB43w";
